<template>
  <div class="proposal-token-history">
    <page-header
      :actions="pageHeaderActionsConfig"
      :page="pageHeaderConfig"
      right-side-class="col-sm-12 col-md-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <filter-manager
      v-model="selectedFilters"
      class="proposal-token-history__filter-manager"
      :display-advanced="false"
      :filters="filtersConfig"
      @academicYear="onAcademicYearChange"
      @search="search"
    />
    <custom-separator class="my-4" text="Resultado de Código de Acesso" />

    <div v-for="(result, index) of page.data" :key="index">
      <token-history-result :value="result" />
    </div>

    <custom-result-not-found
      v-if="page.data.length === 0"
      text="No hay información disponible"
    />

    <pagination
      v-if="page.data.length > 0 && page.totalItemCount > pageSize"
      :data="page"
      show-text
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import TokenHistoryResult from '@/views/provider/proposalHistory/components/TokenHistoryResult.vue';
import {
  getTokenRequestFilters,
  getTokenRequestSearch,
} from '@/modules/serviceProposalHistory/api';

export default {
  name: 'ServiceProposalTokenHistory',
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    Pagination,
    CustomResultNotFound,
    TokenHistoryResult,
  },
  data: () => ({
    selectedFilters: {
      academicYear: null,
      evaluator: null,
      proposalNumber: null,
    },
    filters: {
      academicYears: [],
      evaluators: [],
    },
    page: {
      data: [],
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
    },
    pageSize: 10,
  }),
  computed: {
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filters.academicYears,
          placeholder: 'Seleccione el año',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          clearable: false,
          class: 'col-md-3',
          initialValue: this.selectedFilters.academicYear,
        },
        {
          name: 'evaluator',
          component: 'CustomDropDown',
          options: this.filters.evaluators,
          placeholder: 'Seleccione Evaluador',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
        },
        {
          name: 'proposalNumber',
          component: 'CustomInput',
          placeholder: 'Escriba Número de Propuesta',
          icon: 'fas fa-search color-primary-2',
          leftIcon: true,
          class: 'col-md-5 pr-md-0',
        },
      ];
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Historial Propuesta de Servicio',
        routes: ['Proveedor', 'Historial Propuesta de Servicio'],
      };
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.push({
              name: 'ServiceProposalHistory',
            });
          },
        },
      ];
    },
  },
  async created() {
    await this.getFilters();
  },
  methods: {
    async onAcademicYearChange(academicYear) {
      this.selectedFilters = {
        academicYear,
        evaluator: null,
        proposalNumber: null,
      };
      await this.getFilters();
    },
    async getFilters() {
      await getTokenRequestFilters(this.selectedFilters.academicYear?.id).then(
        (res) => {
          this.filters = { ...res.data };
          this.selectedFilters.academicYear =
            this.selectedFilters.academicYear == null
              ? this.filters.academicYears.find((y) => y.selected)
              : this.selectedFilters.academicYear;
        }
      );
    },
    async search(clear = true) {
      if (clear) {
        this.page.currentPage = 1;
      }
      const params = {
        academicYearId: this.selectedFilters.academicYear.id,
        evaluatorId: this.selectedFilters.evaluator?.id,
        proposalNumber: this.selectedFilters.proposalNumber,
        pageIndex: this.page.currentPage,
      };
      await getTokenRequestSearch(params).then((res) => {
        const page = res.data;
        this.page = { ...page };
      });
    },
    async goToPageHandler(pageNumber) {
      this.page.currentPage = pageNumber;
      await this.search(false);
    },
  },
};
</script>

<style lang="scss" scoped>
.proposal-token-history {
  &__filter-manager ::v-deep {
    @media only screen and (min-width: 768px) {
      .ab-btn.success {
        width: 80%;
      }
    }
  }
}
</style>
